export default __webpack_public_path__ + "static/media/core-value.1c652bbc.jpg";